import { render } from "./BannersImagesSlider.vue?vue&type=template&id=37e01a1d&scoped=true"
import script from "./BannersImagesSlider.vue?vue&type=script&lang=js"
export * from "./BannersImagesSlider.vue?vue&type=script&lang=js"

import "./BannersImagesSlider.vue?vue&type=style&index=0&id=37e01a1d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e01a1d"]])

export default __exports__